import { coalColor } from "../../../styles/theme";
import { IconProps } from "./";

export const FlagIcon = ({
  size = 12,
  color = coalColor,
  className,
}: IconProps) => {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 8 9"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <path
        d="M0 0H4.16978C4.33809 0 4.492 0.0951111 4.56729 0.245684L4.88889 0.888889H7.55556C7.80102 0.888889 8 1.08788 8 1.33333V6.22222C8 6.46769 7.80102 6.66667 7.55556 6.66667H4.71911C4.5508 6.66667 4.39689 6.57156 4.3216 6.42098L4 5.77778H0.888889V8.44444H0V0Z"
        fill={color}
      />
    </svg>
  );
};
